import React, { useState } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';

import Login from './components/Auth/Login';
import FreeLicense from './components/Admin/FreeLicense';
import AdminUserDashboard from './components/Admin/AdminUserDashboard';
import Profile from './pages/Profile';

import ProspectingPreview from './pages/ProspectingPreview';
import Home from './components/Home';
import IndustryExpertise from './components/IndustryExpertise';
import ProspectingForm from './pages/ProspectingForm';
import PrepForm from './components/Prep/PrepForm';
import PostCallForm from './components/PostCall/PostCallForm';
import MainLayout from './components/MainLayout';
import ThreadViewer from './components/ThreadViewer';

function RoutesWithAuth() {
  const [user, setUser] = useState(null);
  const [hasAccess, setHasAccess] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (firebaseUser) => {
    try {
      const docRef = doc(db, 'users', firebaseUser.uid);
      const snap = await getDoc(docRef);

      if (snap.exists()) {
        const data = snap.data();
        if (data.status === 'active') {
          const isAdminFlag = data?.role === 'admin';
          setUser(firebaseUser);
          setHasAccess(true);
          setIsAdmin(isAdminFlag);
          localStorage.setItem('isAdmin', isAdminFlag ? 'true' : 'false');
          navigate('/');
        } else {
          alert("Your account is currently suspended. Please contact support.");
        }
      } else {
        alert("No user record found in Alfred. Please contact support.");
      }
    } catch (err) {
      console.error('Access check error:', err);
      alert("Something went wrong during access check.");
    }
  };

  return (
    <Routes>
      <Route
        path="/admin/grant-access"
        element={
          user && isAdmin ? <FreeLicense /> : <Navigate to="/" replace />
        }
      />

      {!user || !hasAccess ? (
        <Route path="*" element={<Login onLogin={handleLogin} />} />
      ) : (
        <Route path="/" element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/industry" element={<IndustryExpertise />} />
          <Route path="/prospecting-preview" element={<ProspectingPreview />} />
          <Route path="/build-campaign" element={<ProspectingForm />} />
          <Route path="/prep" element={<PrepForm />} />
          <Route path="/post-call" element={<PostCallForm />} />
          <Route path="/thread/:threadId" element={<ThreadViewer />} />
          <Route path="/ask-alfred" element={<h2 style={{ padding: '40px' }}>🤖 Ask Alfred – Coming Soon</h2>} />
          <Route
            path="/admin/users"
            element={
              user && isAdmin ? <AdminUserDashboard /> : <Navigate to="/" replace />
            }
          />
          <Route path="/profile" element={<Profile />} />
        </Route>
      )}
    </Routes>
  );
}

function App() {
  return <RoutesWithAuth />;
}

export default App;
